import * as Yup from 'yup';

export const createPaymentValidationSchema = (type: 'receipt' | 'payment') =>
  Yup.object({
    method: Yup.string()
      .required('Method is required')
      .test('valid-method', 'Invalid method', (value) => {
        if (type === 'payment') {
          return value === 'CashPayment' || value === 'BankPayment';
        } else {
          return value === 'CashReceipt' || value === 'BankReceipt';
        }
      }),
    vouchernumber: Yup.string().required('Voucher number is required'),
    date: Yup.number()
      .required('Date is required')
      .test('positive', 'Date is required', (value) => {
        return value !== 0 && value > 0;
      }),
    paidfrom: Yup.number()
      .nullable()
      .test('required', type === 'payment' ? 'Paid from account is required' : 'Received from account is required', (value) => {
        return value !== null && value !== undefined && value > 0;
      }),
    paidto: Yup.number()
      .nullable()
      .test('required', type === 'payment' ? 'Paid to account is required' : 'Received to account is required', (value) => {
        return value !== null && value !== undefined && value > 0;
      }),
    payableamount: Yup.string()
      .required('Payable amount is required')
      .test('payable-amount-validation', 'Payable amount must be greater than TDS amount', function(value) {
        const payableAmount = parseFloat(value || '0') || 0;
        const tdsAmount = parseFloat(this.parent.tdsamount) || 0;
        
        // Only validate if both amounts are present and greater than 0
        if (payableAmount > 0 && tdsAmount > 0) {
          return payableAmount > tdsAmount;
        }
        return true;
      }),
    tdssection: Yup.string(),
    tdspercentage: Yup.string()
      .test('tds-percentage-validation', 'TDS percentage must be less than 100', function(value) {
        const tdsPercentage = parseFloat(value || '0') || 0;
        
        // Only validate if percentage is present and greater than 0
        if (tdsPercentage > 0) {
          return tdsPercentage < 100;
        }
        return true;
      }),
    tdsamount: Yup.string()
      .test('tds-amount-validation', 'TDS amount must be less than payable amount', function(value) {
        const payableAmount = parseFloat(this.parent.payableamount) || 0;
        const tdsAmount = parseFloat(value || '0') || 0;
        
        // Only validate if both amounts are present, greater than 0, and payable amount is greater than TDS amount
        if (payableAmount > 0 && tdsAmount > 0) {
          return tdsAmount < payableAmount;
        }
        // If TDS amount is 0 or empty, validation passes
        return true;
      }),
    tdsmanual: Yup.number()
      .required('TDS manual is required')
      .test('valid-tds-manual', 'TDS manual must be 0 or 1', (value) => {
        return value === 0 || value === 1;
      }),
    seriesvouchers: Yup.string(),
    bankrefno: Yup.string(),
    remarks: Yup.string(),
    towards: Yup.string(),
    isParty: Yup.boolean().default(false),
  });
